(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[753],{

/***/ 41405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ contactus; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./src/next/components/Head/Head.js + 4 modules
var Head = __webpack_require__(36037);
// EXTERNAL MODULE: ./src/next/components/MainLayout/MainLayout.js + 7 modules
var MainLayout = __webpack_require__(19162);
// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(34412);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../shared/contexts/TranslateContext.js
var TranslateContext = __webpack_require__(48081);
// EXTERNAL MODULE: ../shared/utils/array.js
var array = __webpack_require__(21707);
// EXTERNAL MODULE: ../shared/assets/EgwWebFont.js
var EgwWebFont = __webpack_require__(59034);
// EXTERNAL MODULE: ../shared/components/IconView/IconView.js
var IconView = __webpack_require__(20844);
// EXTERNAL MODULE: ../shared/store/support/actions.js
var actions = __webpack_require__(97580);
// EXTERNAL MODULE: ../shared/store/system/actions.js
var system_actions = __webpack_require__(93893);
// EXTERNAL MODULE: ../shared/hooks/useLoaderById.js
var useLoaderById = __webpack_require__(17604);
// EXTERNAL MODULE: ../shared/components/TextField/TextField.js
var TextField = __webpack_require__(70439);
// EXTERNAL MODULE: ../shared/components/Button/Button.js
var Button = __webpack_require__(18170);
// EXTERNAL MODULE: ../shared/constants.js
var constants = __webpack_require__(75573);
// EXTERNAL MODULE: ../shared/utils/contact-us/constants.js
var contact_us_constants = __webpack_require__(45884);
// EXTERNAL MODULE: ../shared/components/Select/SelectVariantButton.js
var SelectVariantButton = __webpack_require__(80800);
// EXTERNAL MODULE: ../shared/utils/select.js
var utils_select = __webpack_require__(48018);
// EXTERNAL MODULE: ../shared/components/Scroll/Scroll.js
var Scroll = __webpack_require__(95793);
// EXTERNAL MODULE: ../shared/components/Button/LinkLearnHowToUseApps.js
var LinkLearnHowToUseApps = __webpack_require__(7360);
// EXTERNAL MODULE: ../shared/components/index.js + 5 modules
var components = __webpack_require__(58114);
;// CONCATENATED MODULE: ../shared/store/support/constants.js
var KEY_REDUCER_SUPPORT = "support";
;// CONCATENATED MODULE: ../shared/store/support/selectors.js


var selectorSupport = function selectorSupport(state) {
  return state[KEY_REDUCER_SUPPORT];
};

var selectorSupportMainGeneralQuestions = function selectorSupportMainGeneralQuestions(s) {
  return selectorSupport(s).mainGeneralQuestions;
};
var selectorSupportFormSentStatus = function selectorSupportFormSentStatus(s) {
  return selectorSupport(s).formSentStatus;
};
// EXTERNAL MODULE: ../shared/pages/ContactScreen.module.scss
var ContactScreen_module = __webpack_require__(99040);
var ContactScreen_module_default = /*#__PURE__*/__webpack_require__.n(ContactScreen_module);
;// CONCATENATED MODULE: ../shared/pages/ContactScreen.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }























var ContactScreen = function ContactScreen(_ref) {
  var width = _ref.width,
      isMobile = _ref.isMobile,
      isTablet = _ref.isTablet,
      loaderProps = _ref.loaderProps,
      _ref$withNoMargin = _ref.withNoMargin,
      withNoMargin = _ref$withNoMargin === void 0 ? false : _ref$withNoMargin,
      _ref$isStaticWidth = _ref.isStaticWidth,
      isStaticWidth = _ref$isStaticWidth === void 0 ? false : _ref$isStaticWidth;

  var _useSharedTranslation = (0,TranslateContext/* useSharedTranslation */.G)(),
      t = _useSharedTranslation.t;

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState = (0,react.useState)(contact_us_constants/* initErrors */.kl),
      _useState2 = _slicedToArray(_useState, 2),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var _useState3 = (0,react.useState)(contact_us_constants/* initValues */.ae),
      _useState4 = _slicedToArray(_useState3, 2),
      values = _useState4[0],
      setValues = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      files = _useState6[0],
      setFiles = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      dragging = _useState8[0],
      setDragging = _useState8[1];

  var mainGeneralQuestions = (0,es/* useSelector */.v9)(selectorSupportMainGeneralQuestions);
  var formSentStatus = (0,es/* useSelector */.v9)(selectorSupportFormSentStatus);
  var isLoading = (0,useLoaderById/* useLoaderById */.I)(constants/* ComponentsId.CF_SEND_ID */.uB.CF_SEND_ID);
  var isMobileOrTablet = isMobile || isTablet;
  (0,react.useEffect)(function () {
    dispatch(actions/* _sharedActionsSupport.actionFetchCF */._.actionFetchCF());
  }, []);
  (0,react.useEffect)(function () {
    if (!mainGeneralQuestions.length) {
      return;
    }

    var defaultContact = mainGeneralQuestions.find(function (contact) {
      return contact.tag === contact_us_constants/* defaultContactTag */.AE;
    });
    setValues(_objectSpread(_objectSpread({}, values), {}, {
      contact: defaultContact || mainGeneralQuestions[0]
    }));
  }, [mainGeneralQuestions]);
  (0,react.useEffect)(function () {
    if (formSentStatus === constants/* CFStatus.PENDING */.ZX.PENDING) {
      return;
    }

    if (formSentStatus === constants/* CFStatus.SUCCESS */.ZX.SUCCESS) {
      dispatch(system_actions/* _sharedActionsSystem.toast */.g.toast(t("your_mail_sent"), constants/* TOAST_TYPE.success */["do"].success));
    } else {
      dispatch(system_actions/* _sharedActionsSystem.toast */.g.toast(t("sendEmailError"), constants/* TOAST_TYPE.error */["do"].error));
    }
  }, [formSentStatus]);

  var handleChange = function handleChange(item) {
    var option = mainGeneralQuestions.find(function (o) {
      return (0,utils_select/* getOptionKey */._)(o) === item;
    });

    if (option) {
      setValues(_objectSpread(_objectSpread({}, values), {}, {
        contact: option
      }));
    }
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var formData, newErrors;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();

            if (!errors.contact && !errors.name && !errors.email && !errors.message && values.contact && values.name && values.email && values.message) {
              formData = new FormData();
              Object.keys(values).forEach(function (key) {
                return formData.append(key, key === "contact" ? values[key].tag : values[key]);
              });

              if (values.contact.tag === "bug") {
                files.forEach(function (file, index) {
                  formData.append("data" + index, file);
                });
              }

              dispatch(actions/* _sharedActionsSupport.actionSendCF */._.actionSendCF(formData));
              setValues(_objectSpread(_objectSpread({}, values), {}, {
                name: "",
                email: "",
                message: ""
              }));
              setFiles([]);
              dispatch(actions/* _sharedActionsSupport.actionSendCFStatus */._.actionSendCFStatus(constants/* CFStatus.PENDING */.ZX.PENDING));
            } else {
              newErrors = {};

              if (!values.name || values.name === "") {
                newErrors.name = t("error_message_length", {
                  field: "name",
                  length: 3
                });
              }

              if (!values.email || values.email === "") {
                newErrors.email = t("error_message_email");
              }

              if (!values.message || values.message === "") {
                newErrors.message = t("error_message_required", {
                  field: "message"
                });
              }

              if (Object.keys(newErrors).length > 0) {
                setErrors(_objectSpread(_objectSpread({}, errors), newErrors));
              }
            }

          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));

    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var cancelEvent = function cancelEvent(e) {
    e.preventDefault();
    e.stopPropagation();
  };

  var handleDragEnter = function handleDragEnter(e) {
    cancelEvent(e);

    if (!dragging) {
      setDragging(true);
    }
  };

  var handleDragLeave = function handleDragLeave(e) {
    cancelEvent(e);

    if (dragging) {
      setDragging(false);
    }
  };

  var handleFileDrop = function handleFileDrop(e) {
    cancelEvent(e);
    var newFiles = [];
    var fileItems = e.dataTransfer.items;

    if (fileItems) {
      for (var i = 0; i < fileItems.length; i++) {
        if (fileItems[i].kind === "file") {
          newFiles.push(fileItems[i].getAsFile());
        }
      }
    }

    appendFiles(newFiles);
    setDragging(false);
  };

  var appendFiles = function appendFiles(incomingFiles) {
    var allFiles = (0,array/* joinObjArrays */.dl)([incomingFiles, files], "name");
    var totalSize = 0;

    if (allFiles.length > 5) {
      dispatch(system_actions/* _sharedActionsSystem.toast */.g.toast(t("canNotAttachMoreFiles"), constants/* TOAST_TYPE.error */["do"].error));
      return;
    }

    allFiles.forEach(function (file) {
      totalSize += file.size;
    });

    if (totalSize > contact_us_constants/* MAX_FILE_SIZE */.Tb) {
      dispatch(system_actions/* _sharedActionsSystem.toast */.g.toast(t("filesCanNotBeBigger"), constants/* TOAST_TYPE.error */["do"].error));
      return;
    }

    var filesToAppend = [];
    var showWrongFormatMsg = false;
    incomingFiles.forEach(function (file) {
      if (contact_us_constants/* fileFormatRegex.test */.k6.test(file.name.toLowerCase())) {
        filesToAppend.push(file);
      } else {
        showWrongFormatMsg = true;
      }
    });

    if (showWrongFormatMsg) {
      dispatch(system_actions/* _sharedActionsSystem.toast */.g.toast(t("supportedFileFormats"), constants/* TOAST_TYPE.error */["do"].error));
    }

    if (filesToAppend.length > 0) {
      setFiles((0,array/* joinObjArrays */.dl)([filesToAppend, files], "name"));
    }
  };

  var handleFileRemove = function handleFileRemove(file) {
    var deleteIndex = files.findIndex(function (item) {
      return item.name === file.name;
    });

    if (deleteIndex !== -1) {
      files.splice(deleteIndex, 1);
      setFiles(_toConsumableArray(files));
    }
  };

  var handleTextFieldBlur = function handleTextFieldBlur(field, validate) {
    // EGWW-3944
    var error = validate ? validate(field, values[field].trim()) : "";
    setValues(_objectSpread(_objectSpread({}, values), {}, _defineProperty({}, field, values[field].trim())));
    setErrors(_objectSpread(_objectSpread({}, errors), {}, _defineProperty({}, field, error)));
  };

  var renderField = function renderField(field, fieldLabel) {
    var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        rows = _ref3.rows,
        validate = _ref3.validate;

    var isTabletAlbum = arguments.length > 3 ? arguments[3] : undefined;
    return /*#__PURE__*/react.createElement("div", {
      className: classnames_default()((ContactScreen_module_default())["contact-form-row"], (ContactScreen_module_default())["field-".concat(field)], _defineProperty({}, (ContactScreen_module_default())["tablet-album"], isTabletAlbum))
    }, /*#__PURE__*/react.createElement("label", {
      className: (ContactScreen_module_default())["label-form"]
    }, t(fieldLabel), ":"), /*#__PURE__*/react.createElement(TextField/* default */.Z, {
      name: field,
      style: {
        flexBasis: !isMobile ? "60%" : "100%"
      },
      value: values[field],
      error: !!errors[field],
      disabled: isLoading,
      onBlur: function onBlur() {
        return handleTextFieldBlur(field, validate);
      },
      multiline: !!rows,
      helperText: errors[field],
      rows: rows ? rows : 1,
      rootClass: "note-textarea",
      onChange: function onChange(_ref4) {
        var _ref4$target = _ref4.target,
            name = _ref4$target.name,
            value = _ref4$target.value;
        return setValues(_objectSpread(_objectSpread({}, values), {}, _defineProperty({}, name, value)));
      }
    }));
  };

  var renderFileAttach = function renderFileAttach() {
    return /*#__PURE__*/react.createElement("div", {
      className: classnames_default()((ContactScreen_module_default())["drop-view"], _defineProperty({}, (ContactScreen_module_default())["on-drag"], dragging)),
      onDragEnter: handleDragEnter,
      onDrop: handleFileDrop,
      onDragOver: cancelEvent,
      onDragLeave: handleDragLeave
    }, /*#__PURE__*/react.createElement("label", {
      htmlFor: "files-upload",
      className: (ContactScreen_module_default())["cf-label-file"]
    }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
      icon: EgwWebFont/* default.clip */.Z.clip
    }), "\xA0", t("attachFiles")), /*#__PURE__*/react.createElement("input", {
      type: "file",
      name: "files",
      id: "files-upload",
      className: (ContactScreen_module_default())["files-upload"],
      multiple: true,
      onChange: function onChange(e) {
        return appendFiles(Array.from(e.target.files));
      }
    }), /*#__PURE__*/react.createElement("span", {
      className: (ContactScreen_module_default())["attach-desc"]
    }, t("fileLimitationsMsg")));
  };

  var renderFileItem = function renderFileItem(file, index) {
    var _classNames3;

    return /*#__PURE__*/react.createElement("div", {
      className: classnames_default()((ContactScreen_module_default())["cf-file-item"], (_classNames3 = {}, _defineProperty(_classNames3, (ContactScreen_module_default()).tablet, isTablet), _defineProperty(_classNames3, (ContactScreen_module_default()).mobile, isMobile), _classNames3)),
      key: index.toString()
    }, /*#__PURE__*/react.createElement("span", {
      className: (ContactScreen_module_default())["cf-file-title"]
    }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
      icon: EgwWebFont/* default.file */.Z.file
    }), "\xA0", file.name), /*#__PURE__*/react.createElement(Button/* default */.Z, {
      type: "button",
      onClick: function onClick() {
        return handleFileRemove(file);
      },
      title: t("close")
    }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
      icon: EgwWebFont/* default.close */.Z.close
    })));
  };

  var renderFiles = function renderFiles() {
    var content;

    if (width < 890 || files.length === 1) {
      content = files.map(function (file, index) {
        return renderFileItem(file, index);
      });
    } else {
      var leftColumn = [];
      var rightColumn = [];
      files.forEach(function (file, index) {
        var column = index % 2 === 0 ? leftColumn : rightColumn;
        column.push(file);
      });
      content = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
        className: (ContactScreen_module_default())["cf-files-column"]
      }, leftColumn.map(function (file, index) {
        return renderFileItem(file, index);
      })), /*#__PURE__*/react.createElement("div", {
        className: (ContactScreen_module_default())["cf-files-column"]
      }, rightColumn.map(function (file, index) {
        return renderFileItem(file, index);
      })));
    }

    return /*#__PURE__*/react.createElement("div", {
      className: classnames_default()((ContactScreen_module_default())["cf-files-container"], _defineProperty({}, (ContactScreen_module_default()).column, width < 750))
    }, content);
  };

  var renderContent = function renderContent() {
    var _classNames5, _values$contact, _values$contact$name;

    var isDesktopSmall = !isMobileOrTablet && width < 750;
    var isTabletAlbum = isTablet && width > 768;
    var isBagReport = values.contact.tag === "bug";
    var isScrollWrapper = !isMobile && Scroll/* default */.Z;
    var WrapperComponent = isScrollWrapper ? Scroll/* default */.Z : "div";
    var WrapperProps = isScrollWrapper ? {
      hasStaticPosition: true
    } : undefined;
    return /*#__PURE__*/react.createElement(WrapperComponent, WrapperProps, /*#__PURE__*/react.createElement("div", {
      className: classnames_default()((ContactScreen_module_default()).contentMain, (ContactScreen_module_default())["contact-page"], "contact-page")
    }, /*#__PURE__*/react.createElement("div", {
      className: classnames_default()((ContactScreen_module_default())["contact-form-wrap"], (_classNames5 = {}, _defineProperty(_classNames5, (ContactScreen_module_default())["static-width"], isStaticWidth), _defineProperty(_classNames5, (ContactScreen_module_default())["no-margin"], withNoMargin && isDesktopSmall || isTablet), _classNames5))
    }, isLoading ? /*#__PURE__*/react.createElement(components/* Loader */.aN, loaderProps) : /*#__PURE__*/react.createElement("form", {
      onSubmit: handleSubmit
    }, /*#__PURE__*/react.createElement("div", {
      className: classnames_default()((ContactScreen_module_default())["fields-container"], _defineProperty({}, (ContactScreen_module_default())["tablet-album"], isTabletAlbum))
    }, renderField("name", "enter_your_name", {
      validate: function validate(k, v) {
        return v.length < 3 ? t("error_message_length", {
          field: k,
          length: 3
        }) : "";
      }
    }, isTabletAlbum), renderField("email", "enter_your_email", {
      validate: function validate(k, v) {
        return !contact_us_constants/* emailRegExp.test */.LD.test(v) ? t("error_message_email") : "";
      }
    }, isTabletAlbum)), /*#__PURE__*/react.createElement("div", {
      className: (ContactScreen_module_default())["drop-down-container"]
    }, t("chooseSubject"), ":\xA0", /*#__PURE__*/react.createElement(SelectVariantButton/* default */.Z, {
      label: (_values$contact = values.contact) === null || _values$contact === void 0 ? void 0 : (_values$contact$name = _values$contact.name) === null || _values$contact$name === void 0 ? void 0 : _values$contact$name.en,
      buttonProps: {
        variant: Button/* default.variant.clear */.Z.variant.clear,
        color: Button/* default.color.secondary */.Z.color.secondary,
        fontFamily: constants/* FontFamily.roboto */.bt.roboto,
        style: {
          textTransform: "none"
        }
      },
      value: values.contact,
      options: mainGeneralQuestions.map(function (o) {
        return _objectSpread(_objectSpread({}, o), {}, {
          label: o.name.en
        });
      }),
      onChange: handleChange
    })), renderField("message", "enter_your_message", {
      rows: 5,
      validate: function validate(k, v) {
        return v.length === 0 ? t("error_message_required", {
          field: k
        }) : "";
      }
    }), isBagReport && renderFileAttach(), isBagReport && files.length > 0 && renderFiles(), /*#__PURE__*/react.createElement("div", {
      className: classnames_default()((ContactScreen_module_default())["contact-form-row"], (ContactScreen_module_default())["with-submit"])
    }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
      disabled: isLoading,
      onClick: handleSubmit,
      color: Button/* default.color.primary */.Z.color.primary,
      className: classnames_default()((ContactScreen_module_default())["contact-form-send"], _defineProperty({}, (ContactScreen_module_default()).mobile, isMobile))
    }, t("send")))), /*#__PURE__*/react.createElement(LinkLearnHowToUseApps/* LinkLearnHowToUseApps */.m, null))));
  };

  return renderContent();
};

/* harmony default export */ var pages_ContactScreen = (ContactScreen);
// EXTERNAL MODULE: ../shared/styles/variables.module.scss
var variables_module = __webpack_require__(32722);
var variables_module_default = /*#__PURE__*/__webpack_require__.n(variables_module);
// EXTERNAL MODULE: ../shared/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(38295);
// EXTERNAL MODULE: ../shared/components/Loader/Loader.js + 1 modules
var Loader = __webpack_require__(63975);
// EXTERNAL MODULE: ./src/next/hooks/useIsDOMHydratedAfterSSR.js
var useIsDOMHydratedAfterSSR = __webpack_require__(69286);
;// CONCATENATED MODULE: ./src/next/components/ContactScreen/ContactScreen.js
function ContactScreen_slicedToArray(arr, i) { return ContactScreen_arrayWithHoles(arr) || ContactScreen_iterableToArrayLimit(arr, i) || ContactScreen_unsupportedIterableToArray(arr, i) || ContactScreen_nonIterableRest(); }

function ContactScreen_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function ContactScreen_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ContactScreen_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ContactScreen_arrayLikeToArray(o, minLen); }

function ContactScreen_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function ContactScreen_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function ContactScreen_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








var ContactScreen_ContactScreen = function ContactScreen() {
  var _useState = (0,react.useState)((variables_module_default()).desktopWidth),
      _useState2 = ContactScreen_slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var isHydrated = (0,useIsDOMHydratedAfterSSR/* default */.Z)();
  var isMobile = (0,useMediaQuery/* default */.Z)(useMediaQuery/* MEDIA_QUERIES.untilTablet */.q.untilTablet);
  var isTablet = (0,useMediaQuery/* default */.Z)(useMediaQuery/* MEDIA_QUERIES.untilDesktopAndDesktop */.q.untilDesktopAndDesktop);
  var isMobileOrTablet = isMobile || isTablet;
  (0,react.useEffect)(function () {
    setWidth(isMobileOrTablet ? window.width : (variables_module_default()).desktopWidth);
  }, [isMobileOrTablet]);
  return /*#__PURE__*/react.createElement(pages_ContactScreen, {
    width: width,
    isMobile: isMobile && isHydrated,
    isTablet: isTablet && isHydrated,
    loaderProps: {
      isPositionAbsolute: true
    },
    isStaticWidth: true
  });
};

/* harmony default export */ var components_ContactScreen_ContactScreen = (ContactScreen_ContactScreen);
;// CONCATENATED MODULE: ./src/pages/contactus.js





var ContactUs = function ContactUs(_ref) {
  var pageUrl = _ref.pageUrl,
      breadcrumbsProps = _ref.breadcrumbsProps,
      isLoading = _ref.isLoading,
      isLanding = _ref.isLanding;
  return /*#__PURE__*/react.createElement(MainLayout/* default */.Z, {
    breadcrumbs: breadcrumbsProps,
    isLoading: isLoading,
    isLanding: isLanding
  }, /*#__PURE__*/react.createElement(Head/* default */.Z, {
    pageTitle: breadcrumbsProps.title,
    url: pageUrl
  }), /*#__PURE__*/react.createElement(components_ContactScreen_ContactScreen, null));
};

var __N_SSP = true;
/* harmony default export */ var contactus = (ContactUs);

/***/ }),

/***/ 17604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useLoaderById; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34412);
/* harmony import */ var _store_system_selectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91809);


var useLoaderById = function useLoaderById(idOrIds) {
  var loaderIds = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(_store_system_selectors__WEBPACK_IMPORTED_MODULE_1__/* .selectorSystemLoaders */ .Sg);
  return loaderIds.some(function (l) {
    return l === idOrIds;
  });
};

/***/ }),

/***/ 45884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AE": function() { return /* binding */ defaultContactTag; },
/* harmony export */   "LD": function() { return /* binding */ emailRegExp; },
/* harmony export */   "Tb": function() { return /* binding */ MAX_FILE_SIZE; },
/* harmony export */   "ae": function() { return /* binding */ initValues; },
/* harmony export */   "k6": function() { return /* binding */ fileFormatRegex; },
/* harmony export */   "kl": function() { return /* binding */ initErrors; },
/* harmony export */   "zn": function() { return /* binding */ paraPictureRegExp; }
/* harmony export */ });
var defaultContactTag = "egwweb";
var paraPictureRegExp = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/;
var emailRegExp = /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]+$/;
var fileFormatRegex = /(.*?)\.(docx|doc|pdf|xml|bmp|ppt|xls|txt|log|mp4|mov|wmv|flv|avi|mkv|jpeg|jpg|png)$/;
var MAX_FILE_SIZE = 10000000;
var initValues = {
  domain: "main",
  lang: "en",
  contact: "",
  name: "",
  email: "",
  message: ""
};
var initErrors = {
  contact: "",
  name: "",
  email: "",
  message: ""
};

/***/ }),

/***/ 7727:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contactus",
      function () {
        return __webpack_require__(41405);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99040:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"ContactScreen_tablet__91SMV","desktop":"1024","md":"768","lg":"1024","contentMain":"ContactScreen_contentMain__YAxOu","contact-page":"ContactScreen_contact-page__GaA9R","contact-form-wrap":"ContactScreen_contact-form-wrap__GpBva","no-margin":"ContactScreen_no-margin__mIjpr","fields-container":"ContactScreen_fields-container__PNZ93","tablet-album":"ContactScreen_tablet-album__WMxHG","drop-down-container":"ContactScreen_drop-down-container__8Fpee","drop-view":"ContactScreen_drop-view__EgROU","on-drag":"ContactScreen_on-drag__jKMhB","cf-label-file":"ContactScreen_cf-label-file__9VOQx","attach-desc":"ContactScreen_attach-desc__BADWQ","files-upload":"ContactScreen_files-upload__cA_dD","cf-files-container":"ContactScreen_cf-files-container__wThpQ","column":"ContactScreen_column__H65An","cf-files-column":"ContactScreen_cf-files-column__oC2LL","cf-file-item":"ContactScreen_cf-file-item__LtdYu","mobile":"ContactScreen_mobile__ZAMZr","cf-file-title":"ContactScreen_cf-file-title__1BbDp","contact-form-row":"ContactScreen_contact-form-row__bezpX","label-form":"ContactScreen_label-form__fWAbY","with-submit":"ContactScreen_with-submit__38sUW","contact-form-send":"ContactScreen_contact-form-send__AZIZd","contact-form-image":"ContactScreen_contact-form-image__hw5GE","hidden":"ContactScreen_hidden__FZ5ER","static-width":"ContactScreen_static-width__AYYeI","field-helper":"ContactScreen_field-helper__LviY2"};

/***/ }),

/***/ 32722:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [218,239,888,774,179], function() { return __webpack_exec__(7727); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);